module.exports = __webpack_public_path__ + "img/ic-map-address-big.66f01ed7.svg";